import InputField from "@/components/InputField";
import defaultValues from "@/constant/defaultValues";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const SeaFreight = (props) => {
  const { TERM_LIST, OCEAN_TYPE, CONTAINER_TYPE } = defaultValues;
  const {
    errors,
    styleError,
    selectedOceanType,
    handleOceanTypeChange,
    handleFocusOut,
    countries,
    selectedCountryFrom,
    handleCountryFromChange,
    formData,
    handlePortOfOriginChange,
    handleOriginPortInputChange,
    portOfOriginList,
    selectedPortOfOrigin,
    validatePortInput,
    originLoader,
    selectedCountryTo,
    handleCountryToChange,
    handlePortOfDestinationChange,
    handleDestinationPortInputChange,
    portOfDestinationList,
    selectedPortOfDestination,
    destinationLoader,
    handleChange,
    selectedTerm,
    handleTermChange,
    showPickupAddress,
    showDeliveryAddress,
    selectedCbpp,
    handleCbppTypeChange,
  } = props;

  const [nocPlaceholder, setNocPlaceholder] = useState("No of Containers");
  const [cbppPlaceholder, setCbppPlaceholder] = useState(
    "Enter Type of Packaging ",
  );

  useEffect(() => {
    if (selectedOceanType) {
      if (
        selectedOceanType.value === "FCL" ||
        selectedOceanType.value === "DAG_GOODS"
      ) {
        setNocPlaceholder("No of Containers");
      } else if (selectedOceanType.value === "LCL") {
        setNocPlaceholder("No of Containers");
        setCbppPlaceholder("Enter Type of Packaging");
      } else if (selectedOceanType.value == "Bulk") {
        setNocPlaceholder("Cargo Qty");
        setCbppPlaceholder("Enter type of product");
      } else if (selectedOceanType.value === "Ro-Ro") {
        setNocPlaceholder("No of Units");
      } else if (selectedOceanType.value === "Project_Cargo") {
        setNocPlaceholder("No of pieces");
      } else {
        setNocPlaceholder("No of Containers");
      }

      if (selectedOceanType.value === "DAG_GOODS") {
        setCbppPlaceholder("Enter type of packaging");
      }

      if (selectedOceanType.value === "LCL_FCL") {
        setCbppPlaceholder("Enter type of packaging / container");
      }
    }
  }, [selectedOceanType]);

  return (
    <>
      <div className="col-sm-6">
        <div className="input-group">
          <label className="form-label required">Cargo Type</label>
          <div className="input-pad">
            <Select
              name="ocean_type"
              options={OCEAN_TYPE}
              value={selectedOceanType}
              onChange={handleOceanTypeChange}
              placeholder="Select cargo type"
              className="dd-pad"
              noOptionsMessage={() => "No cargo Type Found"}
              onBlur={handleFocusOut}
            />
            {errors.ocean_type && (
              <span className="company-required" style={styleError}>
                {errors.ocean_type}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Origin Country</label>
          <div className="input-pad">
            <Select
              name="country_from"
              options={countries}
              value={selectedCountryFrom}
              onChange={handleCountryFromChange}
              placeholder="Select origin country"
              className="dd-pad"
              onBlur={handleFocusOut}
              noOptionsMessage={() => "No Country Found"}
            />
            {errors.country_from && (
              <span className="company-required" style={styleError}>
                {errors.country_from}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="input-group">
          <label className="form-label required">Port of origin</label>
          <div className="input-pad">
            <CreatableSelect
              name="port_of_origin"
              onChange={handlePortOfOriginChange}
              onInputChange={handleOriginPortInputChange}
              options={portOfOriginList}
              value={selectedPortOfOrigin}
              classNamePrefix={"creatable_react_select"}
              placeholder={`Enter port of origin`}
              formatCreateLabel={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                if (
                  validationError ||
                  validatePortInput(inputValue) ||
                  isEmpty(inputValue)
                ) {
                  return;
                }
                return `Create "${inputValue}"`;
              }}
              isValidNewOption={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                return validationError === null;
              }}
              isLoading={originLoader}
            />

            {errors.port_of_origin && (
              <span className="company-required" style={styleError}>
                {errors.port_of_origin}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Destination Country</label>
          <div className="input-pad">
            <Select
              name="country_to"
              options={countries}
              value={selectedCountryTo}
              onChange={handleCountryToChange}
              placeholder="Select destination country"
              className="dd-pad"
              noOptionsMessage={() => "No Country Found"}
              onBlur={handleFocusOut}
            />
            {errors.country_to && (
              <span className="company-required" style={styleError}>
                {errors.country_to}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Port of destination</label>
          <div className="input-pad">
            <CreatableSelect
              name="port_of_destination"
              onChange={handlePortOfDestinationChange}
              onInputChange={handleDestinationPortInputChange}
              options={portOfDestinationList}
              value={selectedPortOfDestination}
              classNamePrefix={"creatable_react_select"}
              placeholder={`Port of destination`}
              formatCreateLabel={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                if (
                  validationError ||
                  validatePortInput(inputValue) ||
                  isEmpty(inputValue)
                ) {
                  return;
                }
                return `Create "${inputValue}"`;
              }}
              isValidNewOption={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                return validationError === null;
              }}
              isLoading={destinationLoader}
            />

            {errors.port_of_destination && (
              <span className="company-required" style={styleError}>
                {errors.port_of_destination}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          {
            selectedOceanType && (selectedOceanType.value == "Ro-Ro" || selectedOceanType.value == "LCL_FCL") ? <label className="form-label required">Commodity/Product</label> : <label className="form-label required">Commodity</label>
          }

          
          <div className="input-pad">
            <InputField
              type="text"
              name="commodity"
              value={formData.commodity}
              // className="form-control"
              autoComplete="off"
              placeholder={`Enter ${selectedOceanType && (selectedOceanType.value == "Ro-Ro" || selectedOceanType.value == "LCL_FCL") ? 'commodity/product' : 'commodity' } *`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.commodity && (
              <span className="company-required" style={styleError}>
                {errors.commodity}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">HS Code</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="hs_code"
              value={formData.hs_code}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter hs code"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.hs_code && (
              <span className="company-required" style={styleError}>
                {errors.hs_code}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className={`form-label ${selectedOceanType && (selectedOceanType.value == "Bulk" || selectedOceanType.value == "Ro-Ro" || selectedOceanType.value == "LCL") ? "" : "required"}`}>{nocPlaceholder}</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="no_of_containers"
              value={formData.no_of_containers}
              // className="form-control"
              autoComplete="off"
              placeholder={nocPlaceholder}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.no_of_containers && (
              <span className="company-required" style={styleError}>
                {errors.no_of_containers}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          {selectedOceanType && selectedOceanType.value == "FCL" && (
            <label className="form-label required">
              Type of container
            </label>
          )}

          {selectedOceanType &&
            (selectedOceanType.value == "LCL" ||
              selectedOceanType.value == "DAG_GOODS" ||
              selectedOceanType.value == "LCL_FCL" || selectedOceanType.value == "Project_Cargo") && (
              <label className={`form-label ${selectedOceanType.value != "Project_Cargo" ? "required" : ""}`}>
                Type of Packaging
              </label>
            )}

            {
              selectedOceanType && selectedOceanType.value == "Bulk" && <label className="form-label">
                Type of Product
              </label>
            }
          <div className="input-pad">
            {selectedOceanType && selectedOceanType.value == "FCL" && (
              <Select
                name="cbpp"
                options={CONTAINER_TYPE}
                value={selectedCbpp}
                onChange={handleCbppTypeChange}
                placeholder="Select type of container"
                className="dd-pad"
                noOptionsMessage={() => "No container Found"}
                onBlur={handleFocusOut}
              />
            )}
            {selectedOceanType &&
              (selectedOceanType.value == "LCL" ||
                selectedOceanType.value == "DAG_GOODS" ||
                selectedOceanType.value == "LCL_FCL" ||
                selectedOceanType.value == "Bulk" || selectedOceanType.value == "Project_Cargo") && (
                <InputField
                  type="text"
                  name="cbpp"
                  value={formData.cbpp}
                  // className="form-control"
                  autoComplete="off"
                  placeholder={cbppPlaceholder}
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
              )}

            {errors.cbpp && (
              <span className="company-required" style={styleError}>
                {errors.cbpp}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Total Weight (KG)</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="total_weight"
              value={formData.total_weight}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter Total Weight (KG)"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.total_weight && (
              <span className="company-required" style={styleError}>
                {errors.total_weight}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Term</label>
          <div className="input-pad">
            <Select
              name="term"
              options={TERM_LIST}
              value={selectedTerm}
              onChange={handleTermChange}
              placeholder="Select term type"
              className="dd-pad"
              noOptionsMessage={() => "No Term Found"}
              onBlur={handleFocusOut}
            />

            {errors.term && (
              <span className="company-required" style={styleError}>
                {errors.term}
              </span>
            )}
          </div>
        </div>
      </div>
      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showPickupAddress.includes(selectedTerm.value) && (
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Pickup Address</label>
              <div className="input-pad">
                <InputField
                  type="text"
                  name="pickup_address"
                  value={formData.pickup_address}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter pickup address"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.pickup_address && (
                  <span className="company-required" style={styleError}>
                    {errors.pickup_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showDeliveryAddress.includes(selectedTerm.value) && (
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Delivery Address</label>
              <div className="input-pad">
                <InputField
                  type="text"
                  name="delivery_address"
                  value={formData.delivery_address}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter delivery address"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.delivery_address && (
                  <span className="company-required" style={styleError}>
                    {errors.delivery_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default SeaFreight;
